var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg02Board(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1917,
    height: 928,
    viewBox: "0 0 1917 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M390.923 867.462L3.44884 993.907C1.39182 994.578 0 996.497 0 998.66V1053C0 1055.76 2.2386 1058 5.00002 1058H1919C1921.76 1058 1924 1055.76 1924 1053V5.7546C1924 2.39506 1920.75 -0.00853854 1917.54 0.972549L1787.41 40.7058L1735.6 56.2432L1657.68 82.2702C1656.3 82.7333 1655.18 83.78 1654.63 85.1348L1626.19 155.341C1625.42 157.228 1623.59 158.463 1621.55 158.463H1549.06C1546.93 158.463 1545.03 159.811 1544.33 161.822L1515.2 245.657C1514.6 247.362 1513.14 248.615 1511.36 248.936L1340.16 279.85C1338.56 280.138 1337.21 281.184 1336.52 282.653L1251.75 464.055C1250.97 465.721 1249.34 466.825 1247.5 466.93L1097.15 475.542C1095.81 475.618 1094.56 476.232 1093.67 477.245L890.622 709.846C890.325 710.186 889.982 710.485 889.605 710.734L780.305 782.696C779.767 783.05 779.166 783.297 778.534 783.423L574.61 824.12L390.923 867.462Z",
    fill: "url(#paint0_linear_122_360)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_360",
    x1: 415,
    y1: 529,
    x2: 414.716,
    y2: 1217.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0270FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34221,
    stopColor: "#4C9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg02Board);
export default __webpack_public_path__ + "static/media/bg_02_board.e5c512e18f4ceb737808e431918cfdc7.svg";
export { ForwardRef as ReactComponent };